import React from 'react';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import HighlightOffOutlinedIcon from '@mui/icons-material/HighlightOffOutlined';
import { Alert as MUIAlert, AlertTitle } from '@mui/material';

import { Props } from './props';
const AlertView: React.FC<Props> = (props) => {
  const {
    title = 'Alert title',
    theme,
    alertTitleProps,
    description,
    ...rest
  } = props;
  return (
    <MUIAlert
      {...rest}
      severity={theme}
      iconMapping={{
        success: <CheckCircleOutlineIcon />,
        error: <HighlightOffOutlinedIcon />,
      }}
      sx={{
        color: '#E54542',
        ...rest?.sx,
      }}
    >
      <AlertTitle
        {...alertTitleProps}
        sx={{
          fontWeight: 600,
          fontSize: 16,
          marginBottom: 0,
          ...alertTitleProps?.sx,
        }}
      >
        {title}
      </AlertTitle>
      {description && description}
    </MUIAlert>
  );
};

export const Alert = AlertView;
export default AlertView;
